module.exports = __webpack_public_path__ + "static/icons/icon-close-b12cf33426dafdd22fb4181d27fcb3ca.svg";